<template>
    <div class="poi-segment" :class="{ selected: selectedPoi && selectedPoi.includes(segmentData.poiId) }" ref="poi-bit">
        <button aria-hidden="true" @click="setPoi"></button>
        <span aria-hidden="true">{{ segmentData.value }}</span>
        <h3>{{ segmentData.title || "POI Title" }}</h3>
    </div>
</template>

<script>
import { scrollTo } from "@/utils";
import { mapGetters } from "vuex";

export default {
    props: {
        id: String,
        segmentData: Object,
        displayOnly: Boolean,
    },

    computed: {
        ...mapGetters({
            selectedPoi: "handbook/getPoi",
        }),
    },

    methods: {
        setPoi() {
            this.$store.commit("handbook/setPoi", "poi:" + this.segmentData.poiId);
        },
    },

    watch: {
        selectedPoi(value) {
            if (value === "image:" + this.segmentData.poiId) {
                scrollTo(this.$refs["poi-bit"]);
                //sarahs changes
                this.$refs["poi-bit"].querySelector("button").focus();
            }
        },
    },
};
</script>

<style lang="scss"></style>
